import React, { useState, useEffect, useCallback, useMemo } from "react";
import SearchBar from "../SearchBar/SearchBar";
import { Button, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { notify } from "react-notify-toast"
import debounce from 'lodash.debounce';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from "moment";
import dayjs from 'dayjs';
import LocationFilter from "./LocationFilter";
const _ = require('lodash')

const SearchECECTeacherFilter = (props) => {

	const {
		onSearchTeacher
	} = props

	const [searchName, setSearchName] = useState('')
	const [searchFilter, setSearchFilter] = useState({
		name: null,
		locations: [],
		availability: null,
		search_date: null,
		modality: null,
		level: []
	})

	useEffect(() => {
		const strSearch = window.localStorage.getItem('searchTeacherFilter')
		if(strSearch) {
			const currentFilter = JSON.parse(strSearch)
			setSearchFilter(currentFilter)
			setSearchName(currentFilter.name)
		}
		else {
			setSearchFilter({
				name: null,
				locations: [],
				availability: null,
				search_date: null,
				modality: null,
				level: []
			})
		}
	}, [])


	const debouncedOnChange = useCallback((
		debounce((key, value, checked, searchFilterData) => {
			let searchData = {...searchFilterData}
			if(key === 'location') {
				let locations = searchFilterData.locations
				if(value === 'online_only') {
					if(checked) {
						locations = [value]
					}
					else {
						locations = []
					}
				}
				else {
					if(checked && !locations.includes(value)) {
						locations.push(value)
					}
					else if(!checked) {
						locations = locations.filter(ele => ele !== value)
					}
					locations = locations.filter(ele => ele !== 'online_only')
				}
				searchData = {
					...searchFilterData,
					locations 
				}
			}
			else if(key === 'search_date') {
				searchData = {
					...searchFilterData,
					[key]: value,
					availability: null
				}
			}
			else if(key === 'name') {
				searchData = {
					...searchFilterData,
					[key]: value
				}
			}
			else if(key === 'level') {
				let level = searchFilterData.level
				if(checked && !level.includes(value)) {
					level.push(value)
				}
				else if(!checked) {
					level = level.filter(ele => ele !== value)
				}

				searchData = {
					...searchFilterData,
					level 
				}
			}
			else {
				if(checked) {
					searchData = {
						...searchFilterData,
						[key]: value,
						search_date: key === 'availability' ? null : searchData?.search_date
					}
				}
				else {
					searchData = {
						...searchFilterData,
						[key]: null
					}
				}
			}

			setSearchFilter(searchData)
			searchTeacher(searchData)
		}, 600)
	), [])

	const onChange = (key, e, qua = null) => {
		if(key === 'search_date') {
			debouncedOnChange(key, e, true, searchFilter);
		}
		else if(key === 'name') {
			setSearchName(e.target.value)
			debouncedOnChange(key, e.target.value, e.target.checked, searchFilter);
		}
    	else {
			debouncedOnChange(key, e.target.value, e.target.checked, searchFilter);
		}
  	};

	const saveFilter = () => {
		window.localStorage.setItem('searchTeacherFilter', JSON.stringify({...searchFilter}))
		notify.show('Saved filter successfully')
	}

	const removeFilter = () => {
		window.localStorage.removeItem('searchTeacherFilter')
		notify.show('Removed filter successfully')
		setSearchName('')
		const searchData = {
			name: null,
			can_delivers: [],
			full_can_delivers: [],
			locations: [],
			availability: null,
			search_date: null,
			modality: null,
			level: []
		}
		setSearchFilter(searchData)
		searchTeacher(searchData)
	}

	const searchTeacher = (query) => {
		const cloneQuery = {...query}
		const { locations, can_delivers, level } = cloneQuery
		if(locations?.length) {
			locations.forEach((ele, index) => {
				cloneQuery[`locations[${index}]`] = ele
			})
			delete cloneQuery.locations
		}
		if(level?.length) {
			level.forEach((ele, index) => {
				cloneQuery[`level[${index}]`] = ele
			})
			delete cloneQuery.level
		}
		if(can_delivers?.length) {
			can_delivers.forEach((ele, index) => {
				cloneQuery[`can_delivers[${index}]`] = ele
			})
			delete cloneQuery.can_delivers
		}
		delete cloneQuery.full_can_delivers
		onSearchTeacher(cloneQuery)
	}

	return (
		searchFilter && <div className="search-teacher-filters">
		<h2 className="search-teacher-subheading">
			Search by Educator
		</h2>
		<div className="w-100 d-flex justify-content-center">
			<SearchBar
				placeholder="Type name"
				onChange={(e) => onChange('name', e)}
				altColours
				value={searchName}
			/>
		</div>

		<hr className="my-4" />
		<div className="">
			<h2 className="search-teacher-subheading-no-margin mb-3">Search by Location</h2>
			<div className="w-100 d-flex justify-content-center flex-column">
				<LocationFilter onChange={(key, e) => onChange(key, e)} searchFilter={searchFilter} isEcec={true} />
			</div>
		</div>

		<hr className="my-4" />
		<div className="">
			<h2 className="search-teacher-subheading-no-margin">Availability</h2>
			<FormControlLabel
				control={<Checkbox id={'a_nextweek'} value={'next_week'} checked={searchFilter?.['availability'] === 'next_week'} />}
				label={'Available next week'}
				onChange={(e) => onChange('availability', e)}
			/>
			<FormControlLabel
				control={<Checkbox id={'a_next_30_morning'} value={'next_30_morning'} checked={searchFilter?.['availability'] === 'next_30_morning'} />}
				label={'Available mornings for next 30 days'}
				onChange={(e) => onChange('availability', e)}
			/>
			{/* <FormControlLabel
				control={<Checkbox id={'a_next_30_evening'} value={'next_30_evening'} checked={searchFilter?.['availability'] === 'next_30_evening'} />}
				label={'Available evenings for next 30 days'}
				onChange={(e) => onChange('availability', e)}
			/> */}
			<p className="text-center my-2">Or Search by Date</p>
			<div className="w-100 d-flex justify-content-center">
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<StaticDatePicker
						openTo="day"
						// views={['day', 'month', 'year']}
						componentsProps={{ actionBar: { actions: ['clear'] } }}
						value={searchFilter.search_date ? dayjs(moment(searchFilter.search_date, "DD-MM-YYYY").format("MM-DD-YYYY")) : null}
						onChange={(date) => onChange("search_date", date ? moment(date["$d"]).format("DD-MM-YYYY") : null)}
						onAccept={(date) => onChange("search_date", date ? moment(date["$d"]).format("DD-MM-YYYY") : null)}
						onClose={(date) => onChange("search_date", null)}
					/>
				</LocalizationProvider>
			</div>
		</div>

		<>
			<hr className="my-4" />
			<div className="">
				<h2 className="search-teacher-subheading-no-margin mb-3">Qualifications</h2>
				<div className="w-100 d-flex justify-content-center flex-column">
				<Grid container spacing={2}>
					<>
						<Grid item xs={6} style={{ "paddingTop": "4px" }}>
							<FormControlLabel
								control={<Checkbox id={'cert'} value={'cert'} checked={searchFilter?.level?.includes('cert')} />}
								label={'Certificate III'}
								onChange={(e) => onChange('level', e)}
								style={{ "marginBottom": "2px" }}
							/>
						</Grid>
						<Grid item xs={6} style={{ "paddingTop": "4px" }}>
							<FormControlLabel
								control={<Checkbox id={'diploma'} value={'diploma'} checked={searchFilter?.level?.includes('diploma')} />}
								label={'Diploma'}
								onChange={(e) => onChange('level', e)}
								style={{ "marginBottom": "2px" }}
							/>
						</Grid>
						<Grid item xs={6} style={{ "paddingTop": "4px" }}>
							<FormControlLabel
								control={<Checkbox id={'bachelor'} value={'bachelor'} checked={searchFilter?.level?.includes('bachelor')} />}
								label={'Bachelor Degree'}
								onChange={(e) => onChange('level', e)}
								style={{ "marginBottom": "2px" }}
							/>
						</Grid>
						<Grid item xs={6} style={{ "paddingTop": "4px" }}>
							<FormControlLabel
								control={<Checkbox id={'graduate_diploma'} value={'graduate_diploma'} checked={searchFilter?.level?.includes('graduate_diploma')} />}
								label={'Graduate Diploma'}
								onChange={(e) => onChange('level', e)}
								style={{ "marginBottom": "2px" }}
							/>
						</Grid>
					</>
				</Grid>
				</div>
			</div>
		</>

		<div className="my-4 text-center d-flex flex-row">
			<Button className="mx-2" variant="outlined" onClick={() => saveFilter()}>Save these filters on this device</Button>
			<Button className="mx-2" variant="outlined" onClick={() => removeFilter()}>Clear saved filters</Button>
		</div>
	</div>
	)
}

export default SearchECECTeacherFilter